import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import YouTube from 'react-youtube';
import './styles.css';

export default class Cube extends Component {

  constructor() {
    super();
    this._hoverOn = this._hoverOn.bind(this);
    this._hoverOff = this._hoverOff.bind(this);
    this._pressOn = this._pressOn.bind(this);
    this._pressOff = this._pressOff.bind(this);
  }

  componentWillMount() {

    this.setState({ isHovering: false, isPressing: false });
  }

  render() {

    const target = this.props.target;
    if (target && target.route) {
      return (
        <Link className="cube"
             to={target.route}
             onMouseEnter={this._hoverOn}
             onMouseLeave={this._hoverOff}
             onMouseDown={this._pressOn}
             onMouseUp={this._pressOff}>
          <img src={this.props.image} alt={this.props.imageAlt}/>
        </Link>
      );
    }
    return (
      <div className="cube"
           onMouseEnter={this._hoverOn}
           onMouseLeave={this._hoverOff}
           onMouseDown={this._pressOn}
           onMouseUp={this._pressOff}>
        {this.props.youTubeVideoId ? <YouTube videoId="Pv7T_QN46LQ"/> : <img src={this.props.image} alt={this.props.imageAlt}/>}
      </div>
    );
  }

  _hoverOn = () => this.setState({ isHovering: true });

  _hoverOff = () => this.setState({ isHovering: false });

  _pressOn = () => this.setState({ isPressing: true });

  _pressOff = () => this.setState({ isPressing: false });
}



// WEBPACK FOOTER //
// ./src/components/CubeGrid/Cube/index.js